/* eslint-disable */

import {
    DEFAULT_PRODUCT_IMAGE_WIDTH,
    DEFAULT_PRODUCT_IMAGE_HEIGHT,
} from '../config';
import { userService } from '../_services'
import router from '../_router'
import { EventBus } from '@/event-bus.js'
import { BroadcastChannel } from 'broadcast-channel';
import mixpanel from '@/plugins/mixpanel';
import { people } from 'mixpanel-browser';


const user = JSON.parse(localStorage.getItem('user'))
const loginState = user ? { status: { loggedIn: true }, user } : { status: {}, user: null }

let isAdminMode;
try {
    isAdminMode = JSON.parse(localStorage.getItem('isAdminMode'))
} catch {
    isAdminMode = false;
}

// Superuser
const superuser = JSON.parse(localStorage.getItem('superuser'))
const state = {
    ...loginState,
    superuser: superuser ? superuser : {
        token: null,
        user: null,
    },
    isAdminMode,
};


const getters = {
    isSuperuser: state => {
        return state.superuser.token !== null;
    },
    /** if is 'manager'. If browsing as another stylist, always FALSE. */
    isManager: (state, getters) => {
        return state.user.profile.role.includes('manager')
            && !getters.isSuperuser;
    },
    scope: (state, getters) => {
        return state.isAdminMode && getters.isManager ? 'manager' : 'stylist';
    },
    theme: state => {
        return state.user.profile?.theme ?? {
            product_width: DEFAULT_PRODUCT_IMAGE_WIDTH,
            product_height: DEFAULT_PRODUCT_IMAGE_HEIGHT,
            product_display_brand: true,
        };
    },
    canMakeTemplate: (state, getters) => {
        return state.user.profile.ui.can_make_template;
    },
};

const registerMixpanelUser = (user) => {
    mixpanel.identify(user.user.email)

    mixpanel.register({
        'Email': user.user.email,
        'Account Type': user.profile.institution.plan.is_demo ? "Demo" : "Paid",
        'Institution': user.profile.institution.name_for_mixpanel
    })
    mixpanel.people.set_once({
        first_name: user.user.first_name,
        last_name: user.user.last_name,
        email: user.user.email,
        "Institution": user.profile.institution.name_for_mixpanel,
    })

    mixpanel.people.set({
        "Plan": user.profile.institution.plan.name,
        "Is Demo": user.profile.institution.plan.is_demo
    })


}

const actions = {
    saveSuperuser({ commit, state }, { user, token }) {
        commit('setSuperuser', user);
        commit('setSuperuserToken', token);

        localStorage.setItem('superuser', JSON.stringify(
            state.superuser
        ))
    },
    tokenlogin({ dispatch, commit, getters, state }, { token }) {
        return userService.tokenlogin(token)
            .then((r) => {
                const user = r.data
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (user.token) {
                    localStorage.setItem('user', JSON.stringify(user))
                    commit('setAdminMode', false)
                    //   api.defaults.headers.common['Authorization'] = `Token ${user.token}`
                }

                dispatch('loginSuccess', user)
                // Save tokenlogin flag
                localStorage.setItem('isTokenLogin', true)

                // manager-only has to be on admin mode
                if (user.profile.role.includes('manager')) {
                    commit('setAdminMode', true)
                }
                router.push('/dashboard')

                if (getters.isSuperuser) {
                    EventBus.$emit('confirm', {
                        title: 'Success',
                        message: `<div style="margin-bottom: 1rem;">
              You are now signed in as <span class="text-medium">${user.user.first_name} ${user.user.last_name}</strong>.
            </span>`,
                        showOptions: false,
                    });
                }
            })
            .catch((error) => {
                console.log(error)
                commit('loginFailure', error)
                dispatch('alert/error', 'User or password not valid', {
                    root: true,
                })
                throw error;
            })
    },
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', {
            username,
        })
        return userService.login(username, password)
            .then((r) => {
                const user = r.data
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (user.token) {
                    localStorage.setItem('user', JSON.stringify(user))
                }

                dispatch('loginSuccess', user)
                localStorage.setItem('isTokenLogin', false)

                if (user.profile.role.includes('manager')) {
                    commit('setAdminMode', true)
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Admin', {
                            role: 'Admin',
                            account_id: user.user.email,
                        });
                    }
                } else if (user.profile.role.includes('manager-stylist')) {
                    commit('setAdminMode', true)
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Admin/Stylist', {
                            role: 'Admin/Stylist',
                            account_id: user.user.email,
                        });
                    }
                } else if (user.profile.role.includes('stylist')) {
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Stylist', {
                            role: 'Stylist',
                            account_id: user.user.email,
                        });
                    }
                }
                router.push('/dashboard').catch(() => { /*duplicate navigation*/ })
            })
            .catch((error) => {
                console.log(error)
                commit('loginFailure', error)
                var errorMsg = 'User or password not valid'
                if (error?.response?.data?.error?.toLowerCase().includes('too many failed login attempts')) {
                    errorMsg = "Too many login failed attempts. Your account has been locked. We will send you an email to reset your password."
                }
                dispatch('alert/error', errorMsg, {
                    root: true,
                })

                throw error;
            })
    },
    async burberrylogin({ dispatch, commit }, { code }) {
        return userService.sociallogin('burberry', code)
            .then((r) => {
                const user = r.data
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (user.token) {
                    localStorage.setItem('user', JSON.stringify(user))
                }

                dispatch('loginSuccess', user)
                localStorage.setItem('isTokenLogin', false)

                if (user.profile.role.includes('manager')) {
                    commit('setAdminMode', true)
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Admin', {
                            role: 'Admin',
                            account_id: user.user.email,
                        });
                    }
                } else if (user.profile.role.includes('manager-stylist')) {
                    commit('setAdminMode', true)
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Admin/Stylist', {
                            role: 'Admin/Stylist',
                            account_id: user.user.email,
                        });
                    }
                } else if (user.profile.role.includes('stylist')) {
                    if (user.profile.institution.mixpanel_enable) {
                        mixpanel.track('Stylist', {
                            role: 'Stylist',
                            account_id: user.user.email,
                        });
                    }
                }
                router.push('/dashboard').catch(() => { /*duplicate navigation*/ })
            })
            .catch((error) => {
                console.log(error)
                commit('loginFailure', error)
                var errorMsg = 'User or password not valid'
                if (error?.response?.data?.error?.toLowerCase().includes('too many failed login attempts')) {
                    errorMsg = "Too many login failed attempts. Your account has been locked. We will send you an email to reset your password."
                }
                dispatch('alert/error', errorMsg, {
                    root: true,
                })

                throw error;
            })
    },
    salesforcelogin({ commit, dispatch }, { instanceUrl, accessToken }) {
        userService.salesforcelogin(instanceUrl, accessToken)
            .then((r) => {
                const user = r.data
                if (user.token) {
                    localStorage.setItem('user', JSON.stringify(user))
                }

                dispatch('loginSuccess', user)
                localStorage.setItem('isTokenLogin', false)

                if (user.profile.role.includes('manager')) {
                    commit('setAdminMode', true)
                }
                router.push('/dashboard').catch(() => { /*duplicate navigation*/ })
            })
    },
    logout({ commit }) {
        userService.logout()
        // Store wipeout
        commit('entries/reset', null, { root: true })
        commit('customers/reset', null, { root: true })
        commit('products/reset', null, { root: true })


        commit('logout')
        localStorage.removeItem('isTokenLogin')

        const channel = new BroadcastChannel('app-data');
        channel.postMessage('logout');

        if (global.Sfdc) {
            let sfAuthInitUrl = localStorage.getItem('sfauthinit_url')
            let pathStart = sfAuthInitUrl.indexOf('/salesforce/auth_init')
            router.push(sfAuthInitUrl.slice(pathStart))
        }

        //localStorage.removeItem('isAdminMode')
        /* this redirect maks no sense */
        if (user) {
            if (user.profile.role === 'manager')
                commit('setAdminMode', true)
            else
                commit('setAdminMode', false)
            router.push('/dashboard')
        }
    },
    /** 'manual' if manually called in the ux flow. example: UserCardContainer. */
    refresh({ commit, dispatch }, manual = false) {
        if (!localStorage.getItem('user')) {
            return;
        }

        userService.refresh()
            .then((profile) => {
                const user = profile.data
                let local_storage_user = JSON.parse(localStorage.getItem('user'))
                if (!local_storage_user) {
                    /* No session: we skip. Means a logout happened. */
                    return
                }
                if (user.profile.url != local_storage_user.profile.url) {
                    /* 
                        If the session changed while we reloaded the profile
                        we bail. [SEER-284]
                    */
                    console.log("BAIL")
                    return;
                }

                // console.log("REFRESH!!!")
                // console.log(user);

                if (user.token) {
                    localStorage.setItem('user', JSON.stringify(user))
                }

                if (localStorage.getItem('session') == undefined) {
                    let uuidv4 = () => {
                        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                            return v.toString(16);
                        });
                    }
                    //going to store an anonymous sessions
                    localStorage.setItem('session', uuidv4())
                }
                if (user.token) {
                    registerMixpanelUser(user)
                    commit('loginSuccess', user)
                }

                /**
                 * This was changing to admin mode every time the user refreshed.
                 * Without this, the user is landing in admin mode only if the user logged in
                 * from the login page.
                 * @see https://helloseer.monday.com/boards/1831609214/pulses/2004320784
                */
                // if (!manual && user.profile.role.includes('manager')) {
                //     commit('setAdminMode', true)
                // }
            })
    },
    loginSuccess({ commit }, user) {
        registerMixpanelUser(user);
        commit('loginSuccess', user);
    },
    setAdminMode({ commit }, isAdminMode) {
        commit('setAdminMode', isAdminMode)
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = {
            loggingIn: true,
        }
        state.user = user
    },
    /** Stores successful login user data.
     * If isTokenLogin is not defined, uses current value */
    loginSuccess(state, user) {
        state.status = {
            loggedIn: true,
        }
        state.user = user
    },
    loginFailure(state) {
        state.status = {}
        state.user = null
    },
    logout(state) {

        state.status = {}
        state.user = null

        state.superuser = {
            token: null,
            user: null
        }
    },
    setSuperuser(state, user) {
        state.superuser.user = user
    },
    setSuperuserToken(state, token) {
        state.superuser.token = token
    },
    /** Set browsing as manager or stylist.
     * Performs simple validations. */
    setAdminMode(state, isAdminMode) {
        if (isAdminMode) {
            // if (state.superuser.token !== null) {
            //     console.error("Refusing to set admin mode if logged in 'view as stylist' mode.")
            //     return
            // }
            if (!state.user?.profile.role.includes('manager') ?? true) {
                console.error("Refusing to set admin mode for non admin profile")
                return
            }
        }
        state.isAdminMode = isAdminMode
        // persist state
        localStorage.setItem('isAdminMode', isAdminMode)
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
